<template>
    <div class="content"></div>
</template>
<script>
    export default {
        data () {
            return {
                resources: null,
                filters: {
                    query: '',
                    lastFilter: '',
                    period: 'all',
                    advancedFilters: {
                        dateFilter: {
                            start_at: '',
                            end_at: ''
                        },
                    },
                    clientFilter: {
                        client: null,
                        client_id: null,
                        client_type: null,
                        addresses: null
                    },
                    inputs: []
                },
                clientQuery: '',
                customQuery: '',
                paginator: {
                    filter: '',
                    sort: '',
                    order: '',
                    page: 1,
                    last: 1,
                    total: 0,
                    listing: '',
                }
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            setClassDataRaw(aclString, id){
                if( this.$aclInterfaceValidator(aclString, id) ) {
                    return '';
                }else{
                    return 'disable-raw';
                }
            },
            edit: function(id, route){
                let name = this.$route.name + '-edit'
                this.$router.push({ name: name, params: {id: id}});
            },
            duplicate: function(id){
                let ask = confirm("Etes-vous certain de vouloir dupliquer cet élément ?");
                if( ask && this.getResource() ){
                    this.getResource().duplicate(id).then((response) => {
                        this.edit(response.data.id)
                        this.refresh()
                    })
                }
            },
            remove: function(id){
                let ask = confirm("Etes-vous certain de vouloir supprimer cet élément ?");
                if( ask && this.getResource() ){
                    this.getResource().delete(id).then((response) => {
                        this.refresh()
                    })
                }
            },
            forceDelete: function(id){
                let ask = confirm("Etes-vous certain de vouloir supprimer définitivement cet élément ?");
                if( ask && this.getResource() ){
                    this.getResource().forceDelete(id).then((response) => {
                        this.refresh()
                    })
                }
            },
            restore: function(id) {
                let ask = confirm("Etes-vous certain de vouloir restaurer cet élément ?");
                if( ask && this.getResource() ){
                    this.getResource().restore(id).then((response) => {
                        this.refresh()
                    })
                }
            },
            importFile: function(){
                this.$router.push({ name: this.$route.name + '-import'});
            },
            exportFile: function(fileName){

                var d = new Date();
                var dateFile = [
                    d.getFullYear(),
                    ('0' + (d.getMonth() + 1)).slice(-2),
                    ('0' + d.getDate()).slice(-2),
                    ('0' + d.getHours()).slice(-2) + "" + ('0' + d.getMinutes()).slice(-2) + "" + ('0' + d.getSeconds()).slice(-2)
                ].join('-');

                var fileName = fileName || 'export';

                if(this.filters.period == 'custom') {
                    var query = '?query='  + this.filters.query +
                        '&page='   + this.paginator.page +
                        '&order='  + this.paginator.order +
                        '&sort='   + this.paginator.sort +
                        '&filter=' + this.paginator.filter +
                        '&date_start='  + this.filters.advancedFilters.dateFilter.start_at +
                        '&date_end='    + this.filters.advancedFilters.dateFilter.end_at + this.customQuery + this.clientQuery;
                }else{
                    var query = '?query='  + this.filters.query +
                        '&page='   + this.paginator.page +
                        '&order='  + this.paginator.order +
                        '&sort='   + this.paginator.sort +
                        '&filter=' + this.paginator.filter +
                        '&date='   + this.filters.period + this.customQuery + this.clientQuery;
                }

                fileName = fileName + '_' + dateFile + '.xlsx'

                this.getResource().export(query, fileName).then((response) => {
                  if( response && response.data ){
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                  }
                })
                //this.$router.push({ name: this.$route.name + '-export'});
            },
            exportFileForBanana: function(fileName){

              var d = new Date();
              var dateFile = [
                d.getFullYear(),
                ('0' + (d.getMonth() + 1)).slice(-2),
                ('0' + d.getDate()).slice(-2),
                ('0' + d.getHours()).slice(-2) + "" + ('0' + d.getMinutes()).slice(-2) + "" + ('0' + d.getSeconds()).slice(-2)
              ].join('-');

              var fileName = fileName || 'export';

              if(this.filters.period == 'custom') {
                var query = '?query='  + this.filters.query +
                    '&page='   + this.paginator.page +
                    '&order='  + this.paginator.order +
                    '&sort='   + this.paginator.sort +
                    '&filter=' + this.paginator.filter +
                    '&date_start='  + this.filters.advancedFilters.dateFilter.start_at +
                    '&date_end='    + this.filters.advancedFilters.dateFilter.end_at + this.customQuery + this.clientQuery;
              }else{
                var query = '?query='  + this.filters.query +
                    '&page='   + this.paginator.page +
                    '&order='  + this.paginator.order +
                    '&sort='   + this.paginator.sort +
                    '&filter=' + this.paginator.filter +
                    '&date='   + this.filters.period + this.customQuery + this.clientQuery;
              }

              fileName = fileName + '_' + dateFile + '.csv'

              this.getResource().exportForBanana(query, fileName).then((response) => {
                if( response && response.data ){
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', fileName); //or any other extension
                  document.body.appendChild(link);
                  link.click();
                }
              })
              //this.$router.push({ name: this.$route.name + '-export'});
            },
            create: function(params){
                if( params ){
                    this.$router.push({ name: this.$route.name + '-new', params: params});
                }else{
                    this.$router.push({ name: this.$route.name + '-new'});
                }
            },
            resourceLoaded: function(){

            },
            refresh: function(force){
                if( force ){ this.paginator.page = 1; }

                if( this.getResource() ){

                    if(this.filters.period == 'custom') {
                        var query = '?query='  + this.filters.query +
                            '&page='   + this.paginator.page +
                            '&order='  + this.paginator.order +
                            '&sort='   + this.paginator.sort +
                            '&filter=' + this.paginator.filter +
                            '&date_start='  + this.filters.advancedFilters.dateFilter.start_at +
                            '&date_end='    + this.filters.advancedFilters.dateFilter.end_at + this.customQuery + this.clientQuery;
                    }else{
                        var query = '?query='  + this.filters.query +
                            '&page='   + this.paginator.page +
                            '&order='  + this.paginator.order +
                            '&sort='   + this.paginator.sort +
                            '&filter=' + this.paginator.filter +
                            '&date='   + this.filters.period + this.customQuery + this.clientQuery;
                    }

                    this.getResource().query(query).then((response) => {

                        if( response )
                        {
                          this.resources = response.data.data
                          this.paginator.last = response.data.last_page
                          this.paginator.total = response.data.total

                          var field = this.paginator.sort ? this.paginator.sort : null

                          setTimeout(function(){
                            if( field ){
                              var filtering = false;
                              var els = document.querySelectorAll("[data-field]");
                              for (var i = 0, len = els.length; i < len; i++) {
                                els[i].className = els[i].className.replace(" active", "");
                                if( els[i].getAttribute("data-field").indexOf(field) >= 0){
                                  els[i].className += " active";
                                  filtering = true;
                                }
                              }
                              var datagrid = document.querySelectorAll(".datagrid");
                              if( filtering )
                              {
                                datagrid[0].className += " filtering";
                              }else{
                                datagrid[0].className.replace(" filtering", "");
                              }

                            }
                          }, 1)
                          this.resourceLoaded();
                        }

                    })

                }
            },
            setOrder: function(item, sorting){
              this.paginator.order = sorting;
              this.paginator.sort = item.value;
              this.paginator.page = 1;
              this.refresh();
            },
            setFilter: function(field){
                this.paginator.filter = field;
                this.paginator.order = '';
                this.paginator.sort = '';
                this.paginator.page = 1;
                this.refresh();
            },
            resetFilter: function(){
                this.paginator.filter = '';
                this.paginator.order = 'asc';
                this.paginator.sort = '';
                this.filters.query = '';
                this.refresh(true);
            },
            setInputsValue: function(item) {
                this.customQuery = '';
                this.filters.inputs.forEach((item) => {
                    console.log(item.name, item.value)
                    if(typeof item.name !== 'undefined' && typeof item.value !== 'undefined') {
                        if(typeof item.value === 'string' || item.value instanceof String) {
                            this.customQuery = this.customQuery + '&' + item.slug + '_value=' + item.value;
                        }else{
                            if(item.value && item.value.id && typeof item.value.id !== 'undefined') {
                                this.customQuery = this.customQuery + '&' + item.slug + '_model_id=' + item.value.id;
                            }
                        }
                    }
                });
                this.refresh();
            },
            checkAclInterface: function(aclString, id=null) {

                let acl = this.$store.state.user.acl

                if( acl['is_super_admin'] ) {
                    return true;
                }

                if( acl['accept'].includes(aclString) && acl['denied'].includes(aclString) === false ) {
                    return true;
                }

                if( id !== null ) {
                    if( acl['accept'].includes(aclString+id) && acl['denied'].includes(aclString+id) === false ) {
                        return true;
                    }
                }

                return false;
            }
        },
        watch: {
            '$store.getters.scope'(newId, oldId) {
                this.refresh(true);
            },
            'filters.query'(newVal, oldVal) {
                this.refresh(true)
            },
            'filters.advancedFilters.dateFilter.start_at'(newVal, oldVal) {
                this.refresh(true);
            },
            'filters.period'(newVal, oldVal) {
                if(oldVal != newVal && newVal != 'custom') {
                    this.refresh(true);
                }
            },
            'filters.advancedFilters.dateFilter.end_at'(newVal, oldVal) {
                this.refresh(true);
            },
            'filters.clientFilter.client'(newVal, oldVal) {
                console.log('PERSON => ',newVal);
                if(newVal != 'undefined' && newVal != undefined) {
                    if(this.filters.clientFilter.client_type == 'company') {
                        this.clientQuery = '&company_model_id=' + newVal.id
                    }else{
                        this.clientQuery = '&person_model_id=' + newVal.id
                    }
                }else{
                    this.clientQuery = '';
                }
                this.refresh(true);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Index.vue